// extracted by mini-css-extract-plugin
export default {"container":"container__3hjan","Chatbotcontainer":"Chatbotcontainer__zQ7s+"};